var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aboutPageContainer row"},[(_vm.aboutPageType === 'vault')?_c('VaultAbout'):(_vm.aboutPageType === 'marketplace')?_c('MarketplaceAbout'):(_vm.aboutPageType === 'single-marketplace')?_c('SingleMarketplaceAbout'):(_vm.aboutPageType === 'about-authenticators')?_c('AboutAuthenticators'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }